/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
import { Box, Grid } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
// import * as Sentry from "@sentry/react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { useLocation } from "react-router-dom";
import * as Sentry from "@sentry/react";
import AutoCompleteDropdown from "../../../../components/Layout/AutoCompleteDropdown/AutoCompleteDropdown";
// import RadioGroup from "@mui/material/RadioGroup";
import { SERVICES } from "../../../../components/Layout/Services";
import { get } from "../../../../components/Layout/ApiHandler/apihandler";
import InputField from "../../../../components/Layout/fieldInput/InputField";
import DateRangePicker from "../../Components/DateRangePicker/DateRangePicker";

const initialFormValue = {
  contributionDateFrom: "",
  contributionDateTo: "",
  receiptDateFrom: "",
  receiptDateTo: "",
};
const getOptions = (options, key) =>
  options?.map((opt) => ({
    ...opt,
    value: opt[key],
  }));
function ContributionDetailsSearch({
  // updatePayableCity,
  // updatePaymentMethod,
  // updatePaymentGateway,
  // updateUinType,
  // updateReceiptType,
  // onAmountChange,
  clearValues,
  setContributionDetailsSearchValues,
}) {
  const [initialAdvanceFormValue, setInitialAdvanceFormValue] =
    useState(initialFormValue);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
  const [amountFrom, setAmountFrom] = useState("");
  const [amountTo, setAmountTo] = useState("");
  const [receiptNumberFrom, setReceiptNumberFrom] = useState("");
  const [receiptNumberTo, setReceiptNumberTo] = useState("");
  const [chequeNumber, setChequeNumber] = useState("");
  const [ddNumber, setDDNumber] = useState("");
  const [orderId, setOrderId] = useState("");
  //   const dispatch = useDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const handlePaymentMethod = async () => {
    try {
      const url = `${SERVICES.PAYMENT_METHODS}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        // console.log("line no 73", data);
        setPaymentMethods(data.data);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const handleContributionDateChange = (startDate, endDate) => {
    setInitialAdvanceFormValue((prevValues) => ({
      ...prevValues,
      contributionDateFrom: startDate,
      contributionDateTo: endDate,
    }));
  };
  const handleReceiptDateChange = (startDate, endDate) => {
    setInitialAdvanceFormValue((prevValues) => ({
      ...prevValues,
      receiptDateFrom: startDate,
      receiptDateTo: endDate,
    }));
  };
  useEffect(() => {
    handlePaymentMethod();
    setContributionDetailsSearchValues((prevValues) => ({
      ...prevValues,
      selectedPayment: selectedPaymentMethod || "",
      contributionDateTo: initialAdvanceFormValue.contributionDateTo,
      contributionDateFrom: initialAdvanceFormValue.contributionDateFrom,
      amountFrom: amountFrom || "",
      amountTo: amountTo || "",
      receiptNumberFrom: receiptNumberFrom || "",
      receiptNumberTo: receiptNumberTo || "",
      receiptDateFrom: initialAdvanceFormValue.receiptDateFrom,
      receiptDateTo: initialAdvanceFormValue.receiptDateTo,
      chequeNumber: chequeNumber || "",
      ddNumber: ddNumber || "",
      orderId: orderId || "",
    }));
  }, [
    selectedPaymentMethod,
    initialAdvanceFormValue.contributionDateTo,
    initialAdvanceFormValue.contributionDateTo,
    amountFrom,
    amountTo,
    receiptNumberFrom,
    receiptNumberTo,
    initialAdvanceFormValue.receiptDateFrom,
    initialAdvanceFormValue.receiptDateTo,
    chequeNumber,
    ddNumber,
    orderId,
  ]);
  useEffect(() => {
    if (clearValues) {
      setInitialAdvanceFormValue(initialFormValue);
      setSelectedPaymentMethod("");
      setAmountFrom("");
      setAmountTo("");
      setReceiptNumberFrom("");
      setReceiptNumberTo("");
      setChequeNumber("");
      setDDNumber("");
      setOrderId("");
    }
  }, [clearValues]);
  useEffect(() => {
    if (queryParams.get("contributionDateFrom") === null) {
      setInitialAdvanceFormValue((prevValues) => ({
        ...prevValues,
        contributionDateFrom: "",
        contributionDateTo: "",
      }));
    }
    if (queryParams.get("receiptDateFrom") === null) {
      setInitialAdvanceFormValue((prevValues) => ({
        ...prevValues,
        receiptDateFrom: "",
        receiptDateTo: "",
      }));
    }
    if (queryParams.get("modeOfPayment") === null) {
      setSelectedPaymentMethod("");
    }
    if (queryParams.get("amountFrom") === null) {
      setAmountFrom("");
      setAmountTo("");
    }
    if (queryParams.get("receiptNumberFrom") === null) {
      setReceiptNumberFrom("");
      setReceiptNumberTo("");
    }
    if (queryParams.get("chequeNumber") === null) {
      setChequeNumber("");
    }
    if (queryParams.get("orderId") === null) {
      setOrderId("");
    }
  }, [
    queryParams.get("contributionDateFrom"),
    queryParams.get("receiptDateFrom"),
    queryParams.get("modeOfPayment"),
    queryParams.get("amountFrom"),
    queryParams.get("receiptNumberFrom"),
    queryParams.get("chequeNumber"),
    queryParams.get("orderId"),
  ]);
  return (
    <Box sx={{ width: "100%" }}>
      <Grid container rowSpacing={4} columnSpacing={5}>
        <Grid item xs={6}>
          <DateRangePicker
            label="Contribution Date"
            name="contributionDate"
            startDateVal={initialAdvanceFormValue.contributionDateFrom}
            endDateVal={initialAdvanceFormValue.contributionDateTo}
            onChange={handleContributionDateChange}
          />
        </Grid>
        <Grid item xs={6}>
          <AutoCompleteDropdown
            getOptionLabel={(option) => option.name}
            options={getOptions(paymentMethods, "name")}
            label="Mode of Payment"
            name="paymentMethods"
            value={selectedPaymentMethod}
            onChange={(selectedValue) => {
              setSelectedPaymentMethod(selectedValue?.value);
            }}
            inputProps={{ required: false }}
            useHiddenInput
          />
        </Grid>
        {/* <Grid item xs={6}>
          <DateRangePicker
            label="Contribution Date"
            name="contributionDate"
            startDateVal={initialAdvanceFormValue.contributionDateFrom}
            endDateVal={initialAdvanceFormValue.contributionDateTo}
            onChange={handleContributionDateChange}
          />
        </Grid> */}
        <Grid item xs={6}>
          <InputField
            label="Amount From"
            name="amount"
            value={amountFrom}
            onChange={(event) => {
              const { value } = event.target;
              setAmountFrom(value);
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <InputField
            label="Amount To"
            name="amount"
            value={amountTo}
            onChange={(event) => {
              const { value } = event.target;
              setAmountTo(value);
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <InputField
            label="Receipt No. From"
            name="amount"
            value={receiptNumberFrom}
            onChange={(event) => {
              const { value } = event.target;
              setReceiptNumberFrom(value);
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <InputField
            label="Receipt No. To"
            name="amount"
            value={receiptNumberTo}
            onChange={(event) => {
              const { value } = event.target;
              setReceiptNumberTo(value);
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <DateRangePicker
            label="Receipt Date"
            name="receiptDate"
            startDateVal={initialAdvanceFormValue.receiptDateFrom}
            endDateVal={initialAdvanceFormValue.receiptDateTo}
            onChange={handleReceiptDateChange}
            customTop={-235}
          />
        </Grid>
        <Grid item xs={6}>
          <InputField
            label="Order Id"
            name="orderId"
            value={orderId}
            onChange={(event) => {
              const { value } = event.target;
              setOrderId(value);
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <InputField
            label="Cheque Number"
            name="chequeNumber"
            value={chequeNumber}
            onChange={(event) => {
              const { value } = event.target;
              setChequeNumber(value);
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <InputField
            label="DD Number"
            name="ddNumber"
            value={ddNumber}
            onChange={(event) => {
              const { value } = event.target;
              setDDNumber(value);
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
export default ContributionDetailsSearch;
